import { useEffect } from 'react';
import { useGoogleReCaptcha } from 'react-google-recaptcha-v3';

type Props = {
  onVerify: (token: string) => void;
  onUnavailable: () => void;
};

export const ReCaptchaV3 = ({ onVerify, onUnavailable }: Props) => {
  const { executeRecaptcha } = useGoogleReCaptcha();

  useEffect(() => {
    if (!executeRecaptcha) return;

    let cancelled = false;

    const verify = async () => {
      let token: string;
      try {
        token = await executeRecaptcha();
      } catch {
        if (!cancelled) onUnavailable();
        return;
      }

      if (cancelled) return;
      if (token) {
        onVerify(token);
      } else {
        onUnavailable();
      }
    };

    void verify();

    return () => {
      cancelled = true;
    };
  }, [executeRecaptcha, onVerify, onUnavailable]);

  return null;
};
